import { render } from "./WatchlistCreate.vue?vue&type=template&id=39da9f57&ts=true"
import script from "./WatchlistCreate.vue?vue&type=script&lang=ts"
export * from "./WatchlistCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__